<script setup lang="ts">
import { IconLayoutSidebar, IconLayoutSidebarRight } from "@tabler/icons-vue";
import { useLayoutStore } from "~/stores/layout";

const layoutStore = useLayoutStore();
</script>

<template>
    <IconLayoutSidebar v-if="layoutStore.sidebarOpen" class="flex-none size-5 text-zinc-800 dark:text-zinc-300 cursor-pointer" @click="layoutStore.toggleSidebar()" />
    <IconLayoutSidebarRight v-else class="flex-none size-5 text-zinc-800 dark:text-zinc-300 cursor-pointer" @click="layoutStore.toggleSidebar()" />
</template>